import { Component, OnInit, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import {
  AccountLinkCellComponent,
  AlarmCdoSeverityCellComponent,
  AlarmStateCellComponent,
  AlarmStateChangedCellComponent,
  DevOpsAlarm,
  EnvironmentLinkCellComponent,
  ErmDevOpsApiClientService
} from 'erm-sdk';
import * as _ from 'lodash';

@Component({
  standalone: false,
  templateUrl: './alarm-list.component.html',
  styleUrls: ['./alarm-list.component.scss']
})
export class AlarmListComponent implements OnInit {

  isLoading = false;
  alarmGridOptions: GridOptions;
  alarmGridApi?: GridApi;
  selectedAlarm?: DevOpsAlarm;

  greenAlarms?: DevOpsAlarm[];
  redAlarms?: DevOpsAlarm[];
  pendingAlarms?: DevOpsAlarm[];

  @ViewChild('agGrid') agGrid!: AgGridAngular;

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService) {

    this.alarmGridOptions = {
      columnDefs: this.createColumnDefs(),
      enableCellTextSelection: true,
      rowSelection: { mode: 'singleRow' },
      onSelectionChanged: event => {
        this.selectedAlarm = _.first(event.api.getSelectedNodes().map(x => x.data));
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true
      },
      onGridReady: (params: GridReadyEvent) => {
        this.alarmGridApi = params.api;
      }
    };
  }

  async ngOnInit(): Promise<void> {
    return this.refreshAsync();
  }

  async refreshAsync(): Promise<void> {
    try {

      this.isLoading = true;

      // Get alarms
      const getAlarmsResponse = await this.ermDevOpsApiClient.getAlarms();
      const alarms = getAlarmsResponse.body?.alarms || new Array<DevOpsAlarm>();
      this.greenAlarms = _.filter(alarms, x => x.alarmState === 'OK');
      this.redAlarms = _.filter(alarms, x => x.alarmState === 'ALARM');
      this.pendingAlarms = _.filter(alarms, x => x.alarmState === 'INSUFFICIENT_DATA');

      // Initialize grid
      this.alarmGridApi?.setGridOption('rowData', alarms);

    } finally {
      this.isLoading = false;
    }
  }

  private createColumnDefs(): ColDef[] {
    return [
      {
        headerName: 'State',
        field: 'alarmState',
        cellRenderer: AlarmStateCellComponent,
        width: 120,
        sort: 'asc'
      },
      {
        headerName: 'State Changed',
        field: 'alarmStateUpdatedUtc',
        cellRenderer: AlarmStateChangedCellComponent,
        width: 150
      },
      { headerName: 'Name', field: 'alarmName', width: 950, sort: 'asc' },
      {
        headerName: 'Account',
        field: 'accountId',
        cellRenderer: AccountLinkCellComponent,
        width: 110
      },
      {
        headerName: 'Environment',
        field: 'environmentId',
        cellRenderer: EnvironmentLinkCellComponent,
        width: 140
      },
      { headerName: 'Kind', field: 'alarmKind', width: 140 },
      { headerName: 'Service Level', field: 'serviceLevel', width: 140 },
      {
        headerName: 'CDO Severity',
        field: 'cdoSeverity',
        cellRenderer: AlarmCdoSeverityCellComponent,
        width: 140
      },
      { headerName: 'Resource', field: 'resourceName', width: 250 },
      { headerName: 'Metric', field: 'metricName' },
      { headerName: 'Description', field: 'description', width: 350 }
    ];
  }
}
